'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.bindInputElementRef = function (ref) {
      _this.inputElement = ref;
    }, _this.focus = function () {
      _this.inputElement.focus();
    }, _this.render = function () {
      var _classnames;

      var _this$props = _this.props,
          disabled = _this$props.disabled,
          env = _this$props.env,
          name = _this$props.name,
          onChange = _this$props.onChange,
          onKeyDown = _this$props.onKeyDown,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder,
          validation = _this$props.validation,
          value = _this$props.value,
          type = _this$props.type;


      var displayClass = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _styles2.default['input'], true), _defineProperty(_classnames, _styles2.default['input--light'], env === 'light'), _defineProperty(_classnames, _styles2.default['input--dark'], env === 'dark'), _defineProperty(_classnames, _styles2.default['input--critical'], validation === 'error'), _defineProperty(_classnames, _styles2.default['input--success'], validation === 'success'), _defineProperty(_classnames, _styles2.default['input--warning'], validation === 'warning'), _classnames));

      return _react2.default.createElement('input', {
        className: displayClass,
        disabled: disabled,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        'data-hudl-element': name,
        value: value,
        type: type,
        ref: _this.bindInputElementRef
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.focusOnMount) {
        this.focus();
      }
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  disabled: _react.PropTypes.bool,
  env: _react.PropTypes.oneOf(['dark', 'light']),
  focusOnMount: _react.PropTypes.bool,
  name: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  onKeyDown: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  placeholder: _react.PropTypes.string,
  validation: _react.PropTypes.oneOf(['error', 'success', 'warning']),
  value: _react.PropTypes.string,
  type: _react.PropTypes.oneOf(['text', 'password', 'number'])
};
Input.defaultProps = {
  disabled: false,
  env: 'light',
  type: 'text'
};
exports.default = Input;